import React from "react";
import Link from "gatsby-link";

import bg from "./itheoryde-coming-soon.jpeg";
import icon from "./de_auto_premium.png";

import "./styles.css";
import Footer from "../components/footer";
import Downloads from "../components/downloads";
import Features from "../components/features";

const IndexPage = () => (
  <div className="container">
    <div className="header" style={{ backgroundImage: `url(${bg})` }}>
      <div className="header-container">
        <img src={icon} className="app-icon" />
        <h1>iTheorie Führerschein Auto </h1>
        <h2>Die beste Weg, um für die Theorieprüfung zu lernen.</h2>
        <Downloads />
      </div>
    </div>

    <img src={require("./screenshot.png")} />
    <Features />
    <Footer />
  </div>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js